import { PageLoader } from '@forwardflow/ui/PageLoader'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

import { CampaignHome } from './components/CampaignHome'
import { CampaignLeadSourceList } from './components/CampaignLeadSourceList'
import { ActivateCampaignPage } from './components/activate-campaign/ActivateCampaignPage'
import { PhoneNumberPage } from './components/phone-number/PhoneNumberPage'
import { SetAssistants } from './components/assistants/SetAssistants'
import { AgentAssignmentConfig } from './components/agent-assignment/AgentAssignmentConfig'
import { ConfigCampaignPage } from './components/activate-campaign/ConfigCampaignPage'
import {
   CampaignFlowEntry,
   CampaignFlowLive,
   CampaignWorkspace,
} from '@forwardflow/features/campaign-flow'

export const CampaignRoutes = () => {
   return (
      <Suspense fallback={<PageLoader />}>
         <Routes>
            <Route index element={<CampaignFlowEntry />} />
            <Route element={<CampaignHome />}>
               <Route path=":title" element={<CampaignLeadSourceList />} />
            </Route>
            {/* Campaign configuration v2 (enabled organizations only). */}
            <Route path="v2/new" element={<CampaignWorkspace />} />
            <Route path="v2/:id" element={<CampaignWorkspace />} />
            {/* Guided campaign creation: entry, editor, live campaign. */}
            <Route path="flow" element={<CampaignFlowEntry />} />
            <Route path="flow/new" element={<CampaignWorkspace />} />
            <Route path="flow/:id/edit" element={<CampaignWorkspace />} />
            <Route path="flow/:id" element={<CampaignFlowLive />} />
            <Route path=":title/activate" element={<ActivateCampaignPage />} />
            <Route path=":title" element={<ConfigCampaignPage />}>
               <Route path="phone-number" element={<PhoneNumberPage />} />
               <Route path="assistants" element={<SetAssistants />} />
               <Route
                  path="agent-assignment"
                  element={<AgentAssignmentConfig />}
               />
            </Route>
         </Routes>
      </Suspense>
   )
}
